import DIALOGS from "./dialogs"
import ENUMS from "./enums"
import GENERAL from "./general"
import REPORTS from "./reports"
import VALIDATIONS from "./validations"

// Acts as an aggregation object for all shared translations
// and should decreases code duplication.
export default {
  dialogs: DIALOGS,
  enums: ENUMS,
  general: GENERAL,
  reports: REPORTS,
  validations: VALIDATIONS,
} as const
